import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { useState } from "react";
import useSWR from "swr";
import { AutoComplete } from "../../Components/ui/autocomplete";
import { isAuthenticated } from "../../Helpers/Functions";
import {
  getSelectedTripMetaDataPoints,
  getTripsMetaData,
} from "../../lib/PB/Trips";

export const Route = createFileRoute("/Home/")({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({
        to: "/Auth/Login",
      });
    }
  },
  component: Home,
});

export default function Home() {
  const {
    data: trips,
    error: tripsError,
    isLoading: isTripsLoading,
  } = useSWR("/api/trips", getTripsMetaData);
  const [selectedPointsIds, setSelectedPointsIds] = useState<Array<string>>([]);

  const { data: points = [] } = useSWR(
    selectedPointsIds.length
      ? `/api/points/${selectedPointsIds.join(",")}`
      : null,
    () => getSelectedTripMetaDataPoints(selectedPointsIds)
  );

  const [selectedTripDataOpt, setSelectedTripDataOpt] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });

  const [selectedTripPointOpt, setSelectedTripPointOpt] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });

  if (tripsError) return <div>failed to load</div>;
  if (isTripsLoading) return <div>loading...</div>;
  return (
    <div>
      <p>Home</p>
      <div>available trips to subscribe</div>
      <label>select trip</label>
      <AutoComplete
        options={trips?.map((t) => ({ label: t.title, value: t.id }))}
        isLoading={!trips.length}
        placeholder="Select Your Trip"
        onValueChange={(v) => {
          setSelectedTripDataOpt(v);
          const tripIndex = trips.findIndex((t) => t.id === v.value);
          if (tripIndex > -1) {
            setSelectedPointsIds(trips[tripIndex].points);
          }
        }}
        value={selectedTripDataOpt}
        emptyMessage="No resulsts."
      />
      <label>select point</label>
      <AutoComplete
        options={points?.map((p) => ({ label: p.adress, value: p.id }))}
        isLoading={!points?.length}
        placeholder="Select Your Point"
        onValueChange={(v) => setSelectedTripPointOpt(v)}
        value={selectedTripPointOpt}
        emptyMessage="No resulsts."
      />

      <Link
        params={{ TripId: `${selectedTripDataOpt.value}` }}
        to={"/Trips/$TripId/Track"}
      >
        Trip
      </Link>
    </div>
  );
}
